export default ['100', '200', '300', '400', '500', '1000'];
